<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M41.49 9.75l-35.83 6.6a2 2 0 00-1 3.38l7.14 7.14v9.22a2 2 0 003.41 1.41l3.61-3.61 3.76 3.76a2 2 0 003-.24L43.47 12.9a2 2 0 00-1.98-3.15zm-4.14 3.82L13.82 24.7 8.08 19zm-22.6 20.1v-3.8l1.9 1.9zm.58-7.46l22.48-10.65-14 19.14z"/></svg>